import { render, staticRenderFns } from "./ReporteRetenciones.vue?vue&type=template&id=af8c62fe"
import script from "./ReporteRetenciones.vue?vue&type=script&lang=js"
export * from "./ReporteRetenciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports